import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Switch/sgds-switch";
import { register } from "../../utils/ce-registry";

register("sgds-switch", Component);

export default createComponent({
  react: React,
  tagName: "sgds-switch",
  elementClass: Component,
  events: {
    onSgdsChange: "sgds-change"
  }
});
